import React, {useState} from 'react';
import styled from 'styled-components';
import dragHandle from './dragHandle';

import Icon from './Icon';
import Button from './Button';
import Menu from './Menu';
import HoverTooltip from './HoverTooltip';
import { T } from '../components/I18n';
import {isQuestionDeleted} from '../screens/FormBuilderScreen/shared';

function WidgetHeader({id, preview, title, question, options, formulaDeletedQuestions, children}) {
  const deleted = question && isQuestionDeleted(question);
  // Dependent on a question that was deleted
  const hasFormulaWarning = Array.isArray(formulaDeletedQuestions) && formulaDeletedQuestions.length > 0;
  let formulaWarningTooltip = '';
  if (hasFormulaWarning) {
    if (formulaDeletedQuestions.length > 1) {
      formulaWarningTooltip = `Multiple questions used in the formula are deleted: "${formulaDeletedQuestions.map(q => q.text).join('", "')}"`;
    } else {
      formulaWarningTooltip = `A question used in the formula is deleted: "${formulaDeletedQuestions[0].text}"`;
    }
  }

  const [isMenuOpen, toggleMenu] = useState(false);

  let displayMenu = false;
  if (options && options.length > 0 && options[0] !== undefined) {
    displayMenu = true;
  }
  if (preview) {
    displayMenu = false;
  }

  return (
      <StyledWidgetHeader>
        {!preview && (
          <DragHandle>
            <Icon name="align-justify" size="1.5em" />
          </DragHandle>
        )}
        <H4>
          {deleted
            ? (
              <HoverTooltip tooltip="Question was deleted from a published form">
                <DeletedBadge>
                  <T noTranslate>{title || <span>&nbsp;</span>}</T>
                  <Icon color="#D32F2F" size="1em" name="alert-triangle" />
                </DeletedBadge>
              </HoverTooltip>
            )
            : <T noTranslate>{title || <span>&nbsp;</span>}</T>
          }
          {hasFormulaWarning && (
            <HoverTooltip tooltip={formulaWarningTooltip}>
              <FormulaWarningBadge>
                <Icon color="#F9A825" size="1em" name="alert-triangle" />
              </FormulaWarningBadge>
            </HoverTooltip>
          )}
        </H4>
        {children ?
           children: null
        }
        {displayMenu && (
          <>
            <Button id={`${id}_moreMenu`} tertiary onClick={() => toggleMenu(true)}><Icon name="more-vertical" /></Button>
            <Menu open={isMenuOpen} onClose={() => toggleMenu(false)} relativeTo={`${id}_moreMenu`} position="bottom-end">
              {options.map((option, i) => {
                const {title, ...buttonProps} = option;
                  return <Menu.Option key={i} {...buttonProps}>{title}</Menu.Option>;
              })}
            </Menu>
          </>
        )}
      </StyledWidgetHeader>
  );
}

const StyledWidgetHeader = styled.div`
  padding: 1.25rem 1.875rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

const H4 = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  font-weight: 500;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const DeletedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #D32F2F;
  text-decoration: line-through;
  flex-shrink: 0;

  svg {
    text-decoration: none;
  }
`;

const FormulaWarningBadge = styled.span`
  display: inline-flex;
  align-items: center;
  color: #F9A825;
  flex-shrink: 0;
  margin-left: 0.25rem;
`;

const DragHandle = dragHandle(styled.div`
  cursor: grab;
  color: #b4b4b4;
  margin-top: 0.4rem;
  margin-right: 1rem;
`);

export default WidgetHeader;